module.exports = __webpack_public_path__ + "img/person_1.7220f9b.webp";